import React, { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import api from "../api/axios";
import { getBackendAssetsUrl } from "./../config/Production";

export default function Shop() {
  const [backurl, setBackUrl] = useState("");
  const [products, setProducts] = useState([]);
  const productsPerPage = 12;
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(products.length / productsPerPage);

  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = products.slice(
    indexOfFirstProduct,
    indexOfLastProduct
  );

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const Response = await api.get("products/getAll");
        setProducts(Response.data.products);
      } catch (err) {
        console.error(err);
      }
    };
    setBackUrl(getBackendAssetsUrl());
    fetchProducts();
  }, []);

  return (
    <section className="prt-row shop-section clearfix">
      <div className="container">
        {/* Page Header */}
        <div className="section-title title-style-center_text mb-40">
          <div className="title-header">
            <h2 className="cta-title">Bharat Dhara Store</h2>
            <h4 className="cta-titlepre">
              Farm to Plate • Ayurveda • Wellness
            </h4>
          </div>
        </div>

        {/* Filter Row */}
        <div className="row mb-30 align-items-center">
          <div className="col-md-6">
            <select className="form-select w-auto">
              <option>All Categories</option>
              <option>Ayurvedic Medicines</option>
              <option>Wellness Tools</option>
              <option>Organic Foods</option>
            </select>
          </div>

          <div className="col-md-6 text-md-end mt-2 mt-md-0">
            <select className="form-select d-inline-block w-auto">
              <option>Sort by Latest</option>
              <option>Price: Low to High</option>
              <option>Price: High to Low</option>
            </select>
          </div>
        </div>

        {/* Products Grid */}
        <div className="row row-equal-height">
          {currentProducts.length > 0
            ? currentProducts.map((product, i) => {
                const ProductImagesArr = product.product_images.split("|");
                const randomIndex = Math.floor(
                  Math.random() * ProductImagesArr.length
                );
                const randomImage = ProductImagesArr[randomIndex];
                const folderName = product.product_name
                  .toLowerCase()
                  .replaceAll(" ", "_");

                return (
                  <div key={i} className="col-lg-3 col-md-4 col-sm-6 mb-30">
                    <div className="featured-imagebox featured-imagebox-product style1">
                      <div className="featured-thumbnail">
                        <img
                          src={`${backurl}shop_product_listing/${folderName}/${randomImage}_medium.webp`}
                          alt={product.product_name}
                          className="img-fluid"
                        />
                      </div>

                      <div className="featured-content">
                        <div className="featured-title">
                          <h3>
                            <a href={`/product${product.product_url}`}>
                              {product.product_name}
                            </a>
                          </h3>
                          <p
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(
                                product.short_description
                              ),
                            }}
                          ></p>
                        </div>

                        <div className="featured-desc">
                          <p>₹{product.price}</p>
                        </div>

                        <div className="prt-product-btn">
                          <a
                            className="prt-btn prt-btn-size-sm prt-btn-shape-round prt-btn-style-border prt-btn-color-darkcolor mr"
                            href={`/product${product.product_url}`}
                          >
                            View
                          </a>
                          <button
                            className="prt-btn prt-btn-size-sm prt-btn-shape-round prt-btn-style-border prt-btn-color-darkcolor"
                            // onClick={() => addToCart(product)}
                          >
                            Add to Cart
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            : null}
        </div>

        {/* Dynamic Pagination UI */}
        <div className="row">
          <div className="col-12 text-center mt-20">
            <ul className="pagination justify-content-center">
              {/* Previous */}
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => setCurrentPage(currentPage - 1)}
                >
                  Previous
                </button>
              </li>

              {/* Page Numbers */}
              {Array.from({ length: totalPages }, (_, i) => (
                <li
                  key={i}
                  className={`page-item ${
                    currentPage === i + 1 ? "active" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => setCurrentPage(i + 1)}
                  >
                    {i + 1}
                  </button>
                </li>
              ))}

              {/* Next */}
              <li
                className={`page-item ${
                  currentPage === totalPages ? "disabled" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => setCurrentPage(currentPage + 1)}
                >
                  Next
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
